import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import DashboardLayout from "../../components/Layout/dashboardLayout";

import {
  ContactSupport,
  Dashboard,
  ForgotPassword,
  ProviderManagement,
  ReportsManagement,
  ResetPassword,
  ServiceDetails,
  ServiceManagement,
  ServiceProviderDetails,
  SignIn,
  SubAdminManagement,
  UserManagement,
  VerifyOTP,
  AdManagement,
  PromoManagement,
  NotificationManagement,
} from "../../containers";
import SubServicesDetail from "../../containers/ServiceManagement/subServicesDetail";
import DisputeManagement from "../../containers/DisputeManagement";
import DisputeDetail from "../../containers/DisputeManagement/disputeDetail";
import JobManagement from "../../containers/JobManagement";
import JobDetail from "../../containers/JobManagement/jobDetail";
import AssignServiceProvider from "../../containers/JobManagement/AssignServiceProvider";
import BookingManagement from "../../containers/BookingManagement";
import BookingDetail from "../../containers/BookingManagement/BookingDetail";
import SUProfileDashboard from "../../containers/SU/SuProfile";
import SPProfileDashboard from "../../containers/SP/SpProfile";
import AnalyticsDashboard from "../../containers/SpAndSuAnalysis";
import Settings from "../../containers/Settings";
import ServiceCommission from "../../containers/service-commission";

const AuthRoutes = (props) => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.isLoggedIn);
  useEffect(() => {
    if (user) {
      navigate("/dashboard");
    }
  }, [user]);
  return (
    <div className="App">
      {!user ? (
        <Routes>
          <>
            <Route path="/login" element={<SignIn />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/verify-code" element={<VerifyOTP />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </>
        </Routes>
      ) : (
        <Routes>
          <Route element={<DashboardLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/user-management" element={<UserManagement />} />
            <Route
              path="/provider-management"
              element={<ProviderManagement />}
            />
            <Route
              path="/provider-management/details"
              element={<ServiceProviderDetails />}
            />
            <Route path="/service-management" element={<ServiceManagement />} />
            <Route
              path="/service-management/details"
              element={<ServiceDetails />}
            />
            {/* // third layer of service details route */}
            <Route path="/service-management/sub-services/details" element={<SubServicesDetail />} />
            <Route
              path="/sub-admin-management"
              element={<SubAdminManagement />}
            />
            <Route path="/reports-management" element={<ReportsManagement />} />
            <Route path="/contact-support" element={<ContactSupport />} />
            <Route path="/notification-management" element={<NotificationManagement />} />
            <Route path="/ad-management" element={<AdManagement />} />
            <Route path="/promo-management" element={<PromoManagement />} />
            <Route path="/dispute-management" element={<DisputeManagement />} />
            <Route path="/dispute-management-detail/:id" element={<DisputeDetail />} />
            <Route path="/job-management" element={<JobManagement />} />
            <Route path="/job-management-detail/:id" element={<JobDetail />} />
            <Route path="/assign-service-provider/:jobId" element={<AssignServiceProvider />} />
            <Route path="/booking-management" element={<BookingManagement />} />
            <Route path="/booking-detail/:id" element={<BookingDetail />} />
            <Route path="/service-user/:id" element={<SUProfileDashboard />} />
            <Route path="/service-provider/:id" element={<SPProfileDashboard />} />
            <Route path="/analysis" element={<AnalyticsDashboard />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/services-commission" element={<ServiceCommission />} />
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </Route>
        </Routes>
      )}
    </div>
  );
};

export default AuthRoutes;
